module.exports = __webpack_public_path__ + "img/waiting_for_me.5167e0bc.svg";